import { Reducer } from "redux";
import { ITranslationsContainerState } from "./translations";
import { TranslationsAction, ITranslationsSuccessAction } from "./translations.actions";

const initialState: ITranslationsContainerState = {
    translations: {},
};

export const translationsReducer:
    Reducer<ITranslationsContainerState, ITranslationsSuccessAction> = (state = initialState, action): ITranslationsContainerState => {
        switch (action.type) {
            case TranslationsAction.FETCH_SUCCESS: {
                return action.payload;
            }
            default: {
                return state;
            }
        }
    };
